import React from "react";
import { Box, Typography } from "@mui/material";
import Navbar from "../../Components/Navbar";
import Footer from "../Home/Footer";
import HeroSection from "./HeroSection";
import DirectReachUsSection from "./DirectReachUsSection";
import InquireyFormFillSection from "./InquireyFormFillSection";
import OfficesSection from "./OfficesSection";
import GlobalPresenceSection from "./GlobalPresenceSection";
import ScrollToTopButton from "../../Components/ScrollToTopButton";
import useMetaTags from "../../Hooks/UseMetaTags";

const ContactInquireySection = () => {
  useMetaTags({
    title: "Contact Us | Get in Touch",
    description: "Reach out to Abilio Realty's expert team for luxury home inquiries, premium construction details, or custom interior consultations. We are here to help.",
    keywords: "contact abilio realty, corporate offices, real estate inquiry, interior consultation, callback request",
    ogTitle: "Contact Us & Global Support | Abilio Realty",
    ogDescription: "Connect with our advisory teams, visit our branch offices, or submit your custom property inquiries.",
  });

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#FCF9F8",
        position: "relative",
      }}
    >
      <Navbar />

      <Box sx={{ position: "relative" }}>
        <HeroSection />

        {/* Unified Dual-Pane Inquiry Form Section */}
        <Box
          sx={{
            position: "absolute",
            top: "450px", // Maintains the vertical gap from Hero text
            left: "50%",
            transform: "translateX(-50%)", // Horizontally center
            width: "100%",
            maxWidth: "1200px",
            zIndex: 3,
            display: { xs: "none", md: "block" },
            px: { md: 4, lg: 0 },
          }}
        >
          <InquireyFormFillSection />
        </Box>
      </Box>

      {/* Spacer to prevent overlap with Footer and subsequent sections */}
      <Box
        sx={{
          height: { xs: "auto", md: "750px" },
          display: { xs: "none", md: "block" },
          bgcolor: "#FCF9F8",
        }}
      />

      {/* Offices Section (Desktop) */}
      <Box sx={{ pb: 8, pt: 4, display: { xs: "none", md: "flex" }, justifyContent: "center", width: "100%", bgcolor: "#FCF9F8" }}>
        <OfficesSection />
      </Box>

      {/* Global Presence Section */}
      <Box sx={{ pb: { xs: 8, md: 12 }, bgcolor: "#FCF9F8" }}>
        <GlobalPresenceSection />
      </Box>

      {/* Mobile view for Sections */}
      <Box
        sx={{
          display: { xs: "flex", md: "none" },
          flexDirection: "column",
          gap: 4,
          px: 2,
          mt: 4,
          mb: 4,
        }}
      >
        <InquireyFormFillSection />
        <OfficesSection />
      </Box>

      {/* Global Presence Mobile View (included in component) */}

      <Footer />
      <ScrollToTopButton />
    </Box>
  );
};

export default ContactInquireySection;
